import { useState } from 'react';
import { supabase } from '../supabaseClient';
import logo from '../assets/lemon_tree_transparent.png';

export default function Login({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [resetSent, setResetSent] = useState(false);

  async function handleForgotPassword() {
    if (!email) { setError('Enter your email address above first.'); return; }
    setLoading(true); setError('');
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://box.lekkermate.nl',
    });
    if (resetError) { setError('Could not send reset email: ' + resetError.message); setLoading(false); return; }
    setResetSent(true);
    setLoading(false);
  }

  async function handleLogin() {
    if (!email || !password) return;
    setLoading(true);
    setError('');

    const { data, error: authError } = await supabase.auth.signInWithPassword({ email, password });

    if (authError) {
      setError('Invalid email or password');
      setLoading(false);
      return;
    }

    // Fetch profile
    const { data: profile, error: profileError } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', data.user.id)
      .single();

    if (profileError || !profile) {
      setError('Account setup incomplete. Contact your manager.');
      setLoading(false);
      return;
    }

    onLogin(profile);
    setLoading(false);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') handleLogin();
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f0', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '2.5rem', width: '100%', maxWidth: '380px' }}>
        
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src={logo} alt='Lemon Tree' style={{ height: '64px', marginBottom: '1rem' }} />
          <h2 style={{ margin: '0 0 0.25rem', fontSize: '1.3rem' }}>Welcome back</h2>
          <p style={{ margin: 0, color: '#888', fontSize: '0.88rem' }}>Sign in to continue</p>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', fontSize: '0.82rem', color: '#555', marginBottom: '0.4rem', fontWeight: 500 }}>Email</label>
          <input
            type='email'
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder='you@example.com'
            style={{ width: '100%', padding: '0.65rem 0.75rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem', boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', fontSize: '0.82rem', color: '#555', marginBottom: '0.4rem', fontWeight: 500 }}>Password</label>
          <input
            type='password'
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder='••••••••'
            style={{ width: '100%', padding: '0.65rem 0.75rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem', boxSizing: 'border-box' }}
          />
        </div>

        {error && (
          <div style={{ background: '#fff0f0', border: '1px solid #ffcccc', borderRadius: '6px', padding: '0.65rem 0.85rem', marginBottom: '1rem', fontSize: '0.85rem', color: '#cc0000' }}>
            {error}
          </div>
        )}

        <button
          onClick={handleLogin}
          disabled={loading || !email || !password}
          style={{ width: '100%', padding: '0.75rem', background: loading || !email || !password ? '#ccc' : '#1a1a1a', color: '#fff', border: 'none', borderRadius: '6px', cursor: loading || !email || !password ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: '1rem' }}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>

        {resetSent ? (
          <div style={{ marginTop: '1rem', background: '#EAF2EF', border: '1px solid #7EA594', borderRadius: '6px', padding: '10px 12px', fontSize: '0.82rem', color: '#2D7A65', textAlign: 'center' }}>
            Password reset email sent — check your inbox.
          </div>
        ) : (
          <button
            onClick={handleForgotPassword}
            disabled={loading}
            style={{ width: '100%', marginTop: '0.75rem', padding: '0.5rem', background: 'none', border: 'none', color: '#888', fontSize: '0.82rem', cursor: 'pointer', textDecoration: 'underline' }}>
            Forgot password?
          </button>
        )}
      </div>
    </div>
  );
}